import React from 'react';

import { FirmDescriptionStyle } from './FirmDescriptionStyles';

function FirmDescripsion({ account, mw, location }) {
  const description = account?.location?.short_name || account?.location?.city_name;

  if (!description) return null;

  return (
    <FirmDescriptionStyle mw={mw} location={location}>
      {description}
    </FirmDescriptionStyle>
  );
}

export default FirmDescripsion;
